// (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP

import { browserHistory as history } from 'react-router';
import {
  configure, updateHeaders, postLogin, getUserProfile,
  getSession, postResetPassword, postLogout, register, initializeStripe, resetPassword
} from './Api';
import { loadStatus } from './status';
import { watchMasterRoute, ignoreMasterRoute } from './route';
import constants from '../Constants';
export const SESSION_INIT = 'SESSION_INIT';
export const SESSION_LOGIN = 'SESSION_LOGIN';
export const SESSION_LOGIN_SUCCESS = 'SESSION_LOGIN_SUCCESS';
export const SESSION_LOGIN_FAILURE = 'SESSION_LOGIN_FAILURE';
export const SESSION_LOGOUT = 'SESSION_LOGOUT';
export const SESSION_RESET_PASSWORD = 'SESSION_RESET_PASSWORD';
export const SESSION_RESET_PASSWORD_SUCCESS = 'SESSION_RESET_PASSWORD_SUCCESS';
export const SESSION_RESET_PASSWORD_FAILURE = 'SESSION_RESET_PASSWORD_FAILURE';
export const SAVE_USERPROFILE = 'SAVE_USERPROFILE';
export const SAVE_USER_DATA = 'SAVE_USER_DATA';
export const REGISTRATION_STATUS = 'REGISTRATION_STATUS';
export const INITIALIZE_STRIPE = 'INITIALIZE_STRIPE';
export const DISPLAY_PASSWORD_RESET_DAILOG = 'DISPLAY_PASSWORD_RESET_DAILOG';
export const PASSWORD_RESET_STATUS = 'PASSWORD_RESET_STATUS';

let localStorage = window.localStorage;
export function sessionInitialize() {
  if (localStorage.token && localStorage.userId) {
    updateHeaders({ 'Authorization': localStorage.token });
    initialGetUserProfile(localStorage.userId)
  }
  else if (location.pathname.split('/')[1] === constants.ROUTES.SIGNUP) {
    history.push(constants.ROUTES.SIGNUP)
  }
  else {
    history.push(constants.ROUTES.LOGIN)
  }
}

export function sessionLogin(host, userName, password) {
  let token;
  return function (dispatch) {
    dispatch({ type: SESSION_LOGIN, host: host, userName: userName });
    configure({ host: host });
    // history.push(constants.ROUTES.DASHBOARD)
    postLogin(userName, password)
      .then(response => {
        if (response && response.success) {
          token = response.data.sessionToken;
          updateHeaders({ 'Authorization': token });
          try {
            localStorage.userName = response.data.username;
            localStorage.token = token;
            localStorage.userId = response.data.id;
            localStorage.removeItem('logoutAt');
          } catch (e) {
            alert(
              "Unable to preserve session, probably due to being in private" +
              "browsing mode."
            );
          }
          window.location.href = '/' + constants.ROUTES.SITEVIEW;
          // history.replace(constants.ROUTES.DASHBOARD);
          initialGetUserProfile(response.data.id);
        } else {
          alert('Unauthorised user!')
        }

      }).catch(error => dispatch(sessionLoginFailure(error)));

  };
}
export function initialGetUserProfile(userId) {
  getUserProfile(userId)
    .then(response => {
      // alert(response.data.profileImage)
      window.store.dispatch({ type: SAVE_USERPROFILE, result: response.data });
    })
    .catch(error => {
      // console.log('error::', error)
    });
}
export function sessionLoginSuccess(host, userName, token, role,
  needPasswordReset) {
  return {
    type: SESSION_LOGIN_SUCCESS, host: host, userName: userName, token: token,
    role: role, needPasswordReset: needPasswordReset
  };
}

export function sessionLoginFailure(error) {
  // console.log('sessionLoginFailure:', sessionLoginFailure)
  return { type: SESSION_LOGIN_FAILURE, error: error };
}

export function sessionResetPassword(userName, password) {
  return function (dispatch) {
    dispatch({ type: SESSION_RESET_PASSWORD, userName: userName });
    postResetPassword(userName, password)
      .then(() => dispatch(sessionResetPasswordSuccess()))
      .catch(error => dispatch(sessionResetPasswordFailure(error)));
  };
}

export function sessionResetPasswordSuccess() {
  return { type: SESSION_RESET_PASSWORD_SUCCESS, passwordReset: true };
}

export function sessionResetPasswordFailure(error) {
  return { type: SESSION_RESET_PASSWORD_FAILURE, error: error };
}

export function sessionLogout() {
  return function (dispatch) {
    try {
      sessionStorage.clear();
      localStorage.removeItem('userName');
      localStorage.removeItem('token');
      localStorage.removeItem('userId');
      // localStorage.logoutAt = (new Date()).toISOString();
    } catch (e) {
      // ignore
    }
    dispatch({ type: SESSION_LOGOUT });
    postLogout().then(() => {
      // alert('pp')
      window.location.href = '/login';
      // setTimeout(function () {
      //    window.location.reload(true);
      // }, 2000);

    })
    // dispatch(ignoreMasterRoute());


  };
}

export function saveUserData(payload) {
  return (dispatch => {
    dispatch({
      type: SAVE_USER_DATA,
      result: payload
    })
  });
}

export function registerUser(data, userName, password) {
  let result;
  return (dispatch => {
    register(data).then(response => {

      if (response && response.success) {
        result = {
          status: response.success,
          message: "success"
        }
        dispatch({
          type: REGISTRATION_STATUS,
          result
        });

        postLogin(userName, password)
          .then(response => {
            if (response && response.success) {
              let token = response.data.sessionToken;
              updateHeaders({ 'Authorization': token });
              try {
                localStorage.userName = response.data.username;
                localStorage.token = token;
                localStorage.userId = response.data.id;
                localStorage.removeItem('logoutAt');
              } catch (e) {
                alert(
                  "Unable to preserve session, probably due to being in private" +
                  "browsing mode."
                );
              }
              window.location.href = '/' + constants.ROUTES.SITEVIEW;
              // history.replace(constants.ROUTES.DASHBOARD);
              initialGetUserProfile(response.data.id);
            } else {
              alert('Unauthorised user!')
            }

          }).catch(error => dispatch(sessionLoginFailure(error)));
      }
      else if (response && response.success === false) {
        result = {
          status: response.success,
          message: response.error
        }
        dispatch({
          type: REGISTRATION_STATUS,
          result
        });
      }
    })
      .catch(error => {
        if (error) {
          result = {
            status: null,
            message: error
          }
          dispatch({
            type: REGISTRATION_STATUS,
            result
          });
        }
      });
  });
}

export function getStripeAPIKey() {
  return (dispatch => {
    initializeStripe().then(response => {
      dispatch({
        type: INITIALIZE_STRIPE,
        result: response
      });
    });
  });
}

export function displayPasswordResetDialog(value) {
  return (dispatch => {
    dispatch({
      type: DISPLAY_PASSWORD_RESET_DAILOG,
      result: value
    });
    dispatch({
      type: PASSWORD_RESET_STATUS,
      result: ''
    });
  });
}

export function requestPasswordReset(email) {
  return (dispatch => {
    resetPassword(email).then(response => {
      if (response && response.message) {
        dispatch({
          type: PASSWORD_RESET_STATUS,
          result: response && response.message ? response.message : ''
        });
      }
      else {
        dispatch({
          type: PASSWORD_RESET_STATUS,
          result: 'An error occurred when requesting for password reset. Please try again'
        });
      }
    })
      .catch(error => {
        dispatch({
          type: PASSWORD_RESET_STATUS,
          result: error && error.message ? error.message : ''
        });
      });
  })
}


// WEBPACK FOOTER //
// ./src/js/actions/session.js